import withQueryParams from "../../utils/withQueryParams";
import productPageBaseUri from "../../utils/productPageBaseUri";

class SuburbServiceClient {
  constructor(integrationService) {
    this._integrationService = integrationService;
  }

  fetchSuburbs = async (value) => {
    const suburbUri = withQueryParams(
      `${productPageBaseUri}api/suburbs`,
      {
        query: value,
      });

    return this._integrationService.read({
      url: suburbUri,
      method: "GET",
      credentials: "include"
    });
  }
}

export default SuburbServiceClient;
